var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImageTransparentSecurity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 521.4 491.8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M.5.5h343",
    id: "image-transparent-security_svg__a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.5 156.5h343",
    id: "image-transparent-security_svg__b"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "image-transparent-security_svg__c",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 344,
    height: 1,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image-transparent-security_svg__a"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "image-transparent-security_svg__d",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 344,
    height: 1,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image-transparent-security_svg__b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.237)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#1976D2",
    x: 16.186,
    y: 18.814,
    width: 473,
    height: 473,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#E8F1FA",
    width: 473,
    height: 474,
    rx: 8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(103 136)",
    fillRule: "nonzero",
    stroke: "#1976D2",
    strokeDasharray: "0,10",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("use", {
    mask: "url(#image-transparent-security_svg__c)",
    xlinkHref: "#image-transparent-security_svg__a"
  }), /*#__PURE__*/React.createElement("use", {
    mask: "url(#image-transparent-security_svg__d)",
    xlinkHref: "#image-transparent-security_svg__b"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#0D121F",
    fontFamily: "VisbyCF-Medium, Visby CF",
    fontSize: 32,
    fontWeight: 400
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(103 58)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 32
  }, "System Security Plan")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(103 58)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 136
  }, "Cyber Incident "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 180.8
  }, "Response Plan")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(103 58)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 305
  }, "Security Risk "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 349.8
  }, "Management Plan"))), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 52)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#5FDD9D",
    cx: 32,
    cy: 32,
    r: 32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.646 35.718l-7.138-7.436-5.354 5.577 12.492 13.013 23.2-24.167-5.354-5.577z",
    fill: "#FFF"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 179)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#5FDD9D",
    cx: 32,
    cy: 32,
    r: 32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.646 35.718l-7.138-7.436-5.354 5.577 12.492 13.013 23.2-24.167-5.354-5.577z",
    fill: "#FFF"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 348)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#5FDD9D",
    cx: 32,
    cy: 32,
    r: 32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.646 35.718l-7.138-7.436-5.354 5.577 12.492 13.013 23.2-24.167-5.354-5.577z",
    fill: "#FFF"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#00170A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M488.333 32.132l-2.96 2.959c-3.655 3.655-9.43 4.572-13.78 1.781-6.111-3.919-6.752-12.178-1.922-17.007l3.198-3.198a2.735 2.735 0 00-3.867-3.866l-3.198 3.198c-6.405 6.405-6.405 16.79 0 23.197 6.406 6.405 16.791 6.405 23.197 0l3.198-3.198a2.734 2.734 0 10-3.866-3.866"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.932 25.913l-1.58 4.74a.593.593 0 01-1.125 0l-.603-1.808a.593.593 0 00-.374-.374l-1.809-.603c-.54-.18-.54-.945 0-1.125l4.742-1.58a.593.593 0 01.75.75m2.133-5.582h-4.687a7.29 7.29 0 107.29 7.29v-4.687a2.603 2.603 0 00-2.603-2.603"
  })))));
}

export default SvgImageTransparentSecurity;